// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mdBBnZ1ZtjQXkyTx6_cY{justify-content:center;padding-top:80px;display:flex}.xs4f9JzOc7YH0jVuscig{background:var(--background-primary-inverted-primary);box-shadow:var(--shadow-dropdown2);border-radius:12px}.D9lwy8kU4cohSK0nh9_5{flex-direction:column;align-items:center;width:280px;padding:32px 16px 16px;display:flex}.D9lwy8kU4cohSK0nh9_5 .zM5QdpD6DLk1dqjF_QAr{word-break:break-word;flex-direction:column;align-items:center;margin-top:24px;margin-bottom:32px;padding-left:8px;padding-right:8px;display:flex}.D9lwy8kU4cohSK0nh9_5 .jl026LEckTM739731ag7{flex-direction:column;gap:8px;width:100%;display:flex}.duoWYq1fmZkVTpg9OunT{margin-bottom:8px}.CeuOvWo0T1ghvhwNTEpx{text-align:center}.ae6CsEtjiYSW4E1TfxWG{width:100%}.Da5YR_JRhcoPgSYYsfO1{margin-bottom:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `mdBBnZ1ZtjQXkyTx6_cY`,
	"card": `xs4f9JzOc7YH0jVuscig`,
	"info": `D9lwy8kU4cohSK0nh9_5`,
	"content": `zM5QdpD6DLk1dqjF_QAr`,
	"actions": `jl026LEckTM739731ag7`,
	"additionalSecondaryAction": `duoWYq1fmZkVTpg9OunT`,
	"textCenter": `CeuOvWo0T1ghvhwNTEpx`,
	"fullWidth": `ae6CsEtjiYSW4E1TfxWG`,
	"mb12": `Da5YR_JRhcoPgSYYsfO1`
};
export default ___CSS_LOADER_EXPORT___;
